import StandardError from '../StandardError'

export default class NotScheduledError extends StandardError {
  constructor() {
    super(
      'It appears this order has not yet been paid. Requests can only be submitted on completed orders.'
    )
  }
}
